import { Alert, Box, Button, Flex, FormControl, FormLabel, Heading, Select, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setServiceType } from '../reducers/KiidoBookingSlice';
import { setCurrentStep } from '../reducers/LocationSlice';
import { useTranslation } from 'react-i18next';
import { FiInfo } from "react-icons/fi";
import parse from 'html-react-parser';

const WhyThisService = () => {
    const { t, i18n } = useTranslation();
    const [serviceReason, setServiceReason] = useState([])
    const [serviceDescription, setServiceDescription] = useState([])
    const dispatch = useDispatch();
    const { currentStep } = useSelector((state) => state.location);
    const { service } = useSelector((state) => state.booking);

    const services = service?.concerns ? service?.concerns : ''

    const [selectedService, setSelectedService] = useState(null);

    const handleServiceChange = (e) => {
        const selectedOption = services.find(service => service.name === e.target.value);
        // console.log("selectedOption", selectedOption)    
        setSelectedService(selectedOption);
        dispatch(setServiceType(selectedOption));
    };

    const richTextStyles = {
        'h3, h4, h5': {
            marginTop: '1.5rem',
            marginBottom: '1rem',
            fontWeight: 'bold',
        },
        'p': {
            marginBottom: '1rem',
        },
        'ul, ol': {
            marginLeft: '1.5rem',
            marginBottom: '1rem',
        },
        'blockquote': {
            borderLeft: '4px solid',
            borderColor: 'gray.500',
            paddingLeft: '1rem',
            margin: '1rem 0',
            fontStyle: 'italic',
        },
        'table': {
            width: '100%',
            borderCollapse: 'collapse',
            margin: '1rem 0',
        },
        'th, td': {
            border: '1px solid',
            borderColor: 'gray.200',
            padding: '0.5rem',
        },
        'hr': {
            margin: '1.5rem 0',
            border: '0',
            borderTop: '1px solid',
            borderColor: 'gray.200',
        }
    };

    return (
        <>
            <Box p={6} bg="white" borderRadius="md" boxShadow="md">
                <Heading as="h3" size="lg" mb={4} mt={4} color="#FF6666">
                    {t("steps.service_theme")}
                </Heading>
                <Box>
                    <FormControl id="service-type" isRequired >
                        <FormLabel>{t("accompanying_theme")}</FormLabel>
                        <Select
                            placeholder={t("choose_session_theme")}
                            bg="gray.100"
                            onChange={handleServiceChange}
                        >
                            {services && services.length > 0 ? (
                                services.map((service, index) => (
                                    <option key={index} value={service.name}>
                                        {`${i18n.language === 'fr' ? service.name_fr : service.name} - ${service.tariff}€`}
                                    </option>
                                ))
                            ) : (
                                <option disabled>{t("no_service_theme_available")}</option>
                            )}

                        </Select>
                    </FormControl>
                </Box>

                <Flex justifyContent="space-between" mt={4}>
                    <Button
                        onClick={() => dispatch(setCurrentStep(currentStep - 1))}
                        bg="transparent"
                        color="#FF6666"
                        border="2px solid #FF6666"
                        _hover={{ bg: "#FF6666", color: "white" }}
                    >
                        {t('content.pagination.previous')}
                    </Button>

                    <Button
                        onClick={() => dispatch(setCurrentStep(currentStep + 1))}
                        bg="#FF6666"
                        color="white"
                        _hover={{ bg: "#E55353" }}
                        disabled={selectedService === null}
                    >
                        {t('content.pagination.next')}
                    </Button>
                </Flex>
            </Box>
            {selectedService &&
                <Box marginTop={4} padding={4} borderRadius="md" backgroundColor="#CBD5E0" color="#1A202C">                    
                    <Box className="rich-text-content" sx={richTextStyles}>
                        {parse(i18n.language === "en" ? selectedService?.description_en : selectedService?.description_fr)}
                    </Box>
                </Box>
            }
        </>

    )
}

export default WhyThisService